export const notFound = {
  title: 'Oops! Page not Found',
  description1: 'Something went wrong.',
  description2: 'It looks like the link is broken or the page has been removed',
  button: 'Back to Home',
};
